import { FC } from 'react';
import { Text } from '@connect-x-app/hybrid-ui';
import { FontSize } from '@connect-x-app/shared-ui';
import classnames from 'classnames';

type Props = {
  isActiveTab: boolean;
  name: string;
  setTab: () => void;
  textSize?: FontSize;
};

export const Tab: FC<Props> = ({ isActiveTab, name, setTab, textSize = 'XL' }) => {
  return (
    <li className={classnames('nav-bar-sub-li', { isActiveTab })} key={name} onClick={setTab}>
      <Text size={textSize} weight="bold">
        {name}
      </Text>
    </li>
  );
};
